/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stock_Out_Suggestion_ErrorInputs */

const vi_stock_out_suggestion_error = /** @type {(inputs: Stock_Out_Suggestion_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tải được gợi ý lô để xuất kho. Thử lại sau.`)
};

/**

* @param {Stock_Out_Suggestion_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stock_out_suggestion_error = /** @type {((inputs?: Stock_Out_Suggestion_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stock_Out_Suggestion_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stock_out_suggestion_error(inputs)
});